import { render, staticRenderFns } from "./remote_diagnosis.vue?vue&type=template&id=9ea2e860&scoped=true"
import script from "./remote_diagnosis.vue?vue&type=script&lang=js"
export * from "./remote_diagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea2e860",
  null
  
)

export default component.exports